module.exports = __webpack_public_path__ + "static/media/info-modal-icon.69e336c1.svg";